<template>
  <div class="footer-wrap">
    <div class="footer-inner">
      <div class="footer-item">
        <h4></h4>
        <div class="img-wrap">
          <img class="qrcode" src="../assets/qrcode.png" alt>
        </div>
        <!-- <qrcode-vue class="qrcode" :value="qrLink" size="163"></qrcode-vue> -->
        <p class = "qrcode_text">PBSD官方交流群</p>
      </div>
      <ul class="contact-items">
        <li class="contact-item">
          <img class="icon-img" src="../assets/map.png" alt>
          <h4>公司地址</h4>
          <p class="detail">广州市天河区兴民路天盈广场东塔
          </p>
        </li>
        <li class="contact-item">
          <img class="icon-img" src="../assets/email.png" alt>
          <h4>技术支持邮箱</h4>
          <p class="detail">wilsonwu@wwforu.com</p>
        </li>
        <li class="contact-item">
          <img class="icon-img" src="../assets/tel.png" alt>
          <h4>技术支持热线</h4>
          <p class="detail">-- 热线建立中 --</p>
        </li>
      </ul>
    </div>
    <div class="footer-copyright">
      <p class="text">广州市贯微建筑科技有限公司. Copyright 2022 gwforu.com. </p>
      <p ><a class="text" target="_blank" href="https://beian.miit.gov.cn">粤ICP备2021037558号</a></p>
    </div>
  </div>
</template>
<script>
// import QrcodeVue from 'qrcode.vue'




export default {
  name: 'scan',
  components: {
    // QrcodeVue
  },
  data() {
    return {
      qrLink: 'test'
    }
  }
}
</script>

<style lang="less" scoped>
.footer-wrap {
  background: #2a59c4;
  font-family: 'Microsoft YaHei';
  .footer-inner {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    padding: 46px 100px 16px 100px;//上,右,下,左
    display: flex;
    align-items: center;
    .contact-items {
      display: flex;
    }
    .footer-item,
    .contact-item {
      width: 220px;
      h4 {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
      }
      .icon-img {
        width: 48px;
        margin-bottom: 20px;
      }
      // .qrcode {
      //   margin-top: 9px;
      //   margin-bottom: 9px;
      // }
      .detail {
        margin-top: 16px;
        font-size: 14px;
        line-height: 20px;
      }
      .qrcode_text{
        font-size: 14px;
        text-align: center;
        font-weight: 500;
      }
    }
    .footer-item {
      margin-right: 50px;
    }
  }
  .footer-copyright {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    display: block;
    align-items: center;
    padding: 0px 100px 16px 100px;//上,右,下,左
    .text{
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        line-height: 25px;
        color: white;
      }
  }
  .img-wrap {
    margin-top: 9px;
    box-sizing: border-box;
    margin-bottom: 13px;
    img {
      background: #ffffff;
      padding: 4px;
      width: 140px;
    }
  }
}
@media screen and (max-width: 990px) {
  .footer-wrap {
    .footer-inner {
      flex-direction: column;
      .contact-items {
        flex-direction: column;
      }
      .footer-item {
        margin-right: 0;
        margin-bottom: 46px;
      }
      .contact-item {
        margin-bottom: 30px;
      }
    }
  }
}
</style>

